import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';
import { useWizard } from '@zillow/zrs-rental-applications';
import { FORBIDDEN_IP_SUBSTEP, GENERIC_ERROR_SUBSTEP } from '../constants/steps';
import { useIdVerificationWebApiHandler_isIpAddressInTheUs } from '@zg-rentals/ts-id-verification-client-react-query';
import { IdvStep, LogLevel } from '../../../models';
import IdvSpinner from '../IdvSpinner';
import { useIdVerificationCallbacks } from '../contexts/IdVerificationContext';

export default function IpAddressWrapper({ children }: PropsWithChildren) {
  const { onRequestStep } = useWizard();
  const { log } = useIdVerificationCallbacks();
  const { isLoading, data: ipAddressInTheUs, error } = useIdVerificationWebApiHandler_isIpAddressInTheUs();
  useEffect(() => {
    if (error) {
      log(LogLevel.Error, {
        message: 'Error checking if IP Address is in US',
        error,
      });
      onRequestStep(IdvStep.ErrorStep, GENERIC_ERROR_SUBSTEP);
    } else if (!isLoading && !ipAddressInTheUs) {
      onRequestStep(IdvStep.ErrorStep, FORBIDDEN_IP_SUBSTEP);
    }
  }, [error, isLoading, ipAddressInTheUs, log, onRequestStep]);

  return isLoading ? <IdvSpinner /> : children;
}
